// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mJZVd6U7FQhXfLC93P9I{text-decoration:none}.XpTwqljIKkWGfIDVNV7b{width:109px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"guideButton": `mJZVd6U7FQhXfLC93P9I`,
	"createButton": `XpTwqljIKkWGfIDVNV7b`
};
export default ___CSS_LOADER_EXPORT___;
